import { FC, useEffect, useState } from "react";
import { RouteComponentProps, withRouter } from "react-router";
import { Link } from "react-router-dom";
import { Routes } from "../../../constants/routes";
import InnerLayout from "../innerLayout/InnerLayout";
import "./Report.css"
import { ReportSubscriptionType, ReportSubscription, getReportSubscriptions, reportSubscribe, reportUnsubscribe } from "../../../api/reportsApi";
import GlobalSpinner from "../../components/globalsSpinner/GlobalSpinner";
import ReportDashboard from "../../components/reportDashboard/ReportDashboard";

export interface ReportsProps  extends RouteComponentProps<any>
{
    logOut : () => void;
    toogleCollapse: () => void;
    isCollapsed: boolean;
}


const Reports:FC<ReportsProps> = (props) => {
    let {logOut, toogleCollapse, isCollapsed} = props;

    return <InnerLayout 
                activeTab="reports" 
                logOut={logOut} 
                toogleCollapse={toogleCollapse} 
                isCollapsed={isCollapsed}
            >
                <>
                    <ReportDashboard {...props} />
                </>                                
    </InnerLayout>

}

export default withRouter(Reports);